// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-fwwgl-zxwd-index-main_right_content-3NiFH","table":"components-fwwgl-zxwd-index-table-2WWib","search_box":"components-fwwgl-zxwd-index-search_box-1MT-D","card_button":"components-fwwgl-zxwd-index-card_button-2tzBh"};


//////////////////
// WEBPACK FOOTER
// ./components/fwwgl/zxwd/index.css
// module id = 2291
// module chunks = 0